export enum Tasks {
  shot1 = '0',
  shot2 = '1',
  shot3 = '2',
  shot4 = '3',
  shot5 = '4',
}
